import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';
import { ExternalLink } from 'lucide-react';
import { mockProjects } from '../mockData';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section id="creations" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="section-title">Nos Créations Scratch</h2>
        <p className="text-center text-xl text-[#6C757D] mb-16 max-w-3xl mx-auto">
          Découvre les projets créés par notre équipe ! Tu peux les essayer directement sur cette page.
        </p>

        <div className="relative px-12">
          <Carousel
            opts={{
              align: "center",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {mockProjects.map((project) => (
                <CarouselItem key={project.id} className="md:basis-1/2 lg:basis-1/3">
                  <div className="p-4">
                    <Card className="project-card hover:shadow-xl transition-all duration-300 h-full">
                      <CardHeader>
                        <div className="flex items-start justify-between mb-2">
                          <CardTitle className="text-xl">{project.title}</CardTitle>
                          <Badge className={`${project.badgeColor} text-white shrink-0`}>
                            {project.category}
                          </Badge>
                        </div>
                        <CardDescription className="text-base">
                          {project.description}
                        </CardDescription>
                      </CardHeader>
                      <CardContent>
                        <div className="aspect-video bg-gradient-to-br from-[#FF6B35]/10 to-[#9966FF]/10 rounded-lg flex items-center justify-center border-2 border-dashed border-[#9966FF]/30 overflow-hidden">
                          <iframe
                            src={`https://scratch.mit.edu/projects/${project.scratchId}/embed`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            scrolling="no"
                            allowFullScreen
                            title={project.title}
                            className="pointer-events-none"
                          />
                        </div>
                      </CardContent>
                      <CardFooter>
                        <Button 
                          onClick={() => setSelectedProject(project)}
                          className="w-full bg-[#FF6B35] hover:bg-[#FF6B35]/90 text-white"
                        >
                          Jouer au projet
                        </Button>
                      </CardFooter>
                    </Card>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="bg-white shadow-lg hover:bg-[#FF6B35] hover:text-white transition-colors" />
            <CarouselNext className="bg-white shadow-lg hover:bg-[#FF6B35] hover:text-white transition-colors" />
          </Carousel>
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-[#6C757D]">
            ← Utilise les flèches pour découvrir tous nos projets →
          </p>
        </div>
      </div>

      {/* Project Dialog */}
      <Dialog open={selectedProject !== null} onOpenChange={() => setSelectedProject(null)}>
        <DialogContent className="max-w-4xl w-full">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-between">
              <span>{selectedProject?.title}</span>
              <Badge className={`${selectedProject?.badgeColor} text-white`}>
                {selectedProject?.category}
              </Badge>
            </DialogTitle>
            <DialogDescription>
              {selectedProject?.description}
            </DialogDescription>
          </DialogHeader>
          <div className="w-full aspect-video bg-[#F8F9FA] rounded-lg overflow-hidden">
            {selectedProject && (
              <iframe
                src={`https://scratch.mit.edu/projects/${selectedProject.scratchId}/embed`}
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                title={selectedProject.title}
              />
            )}
          </div>
          <div className="flex justify-end">
            <Button
              variant="outline"
              onClick={() => window.open(`https://scratch.mit.edu/projects/${selectedProject?.scratchId}/`, '_blank')}
              className="flex items-center space-x-2"
            >
              <span>Voir sur Scratch.mit.edu</span>
              <ExternalLink size={16} />
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Projects;